// Mirror of the API's src/subscriptions/enums/plan-tier.ts.
//
// Plan codes carry a tier and a billing cycle (PROFESSIONAL_MONTHLY,
// ENTERPRISE_ANNUAL), and several screens compared them with startsWith. That
// silently drops any plan whose code does not begin with its tier name:
// CHARTER_ANNUAL is Professional in every respect, but matched none of them and
// fell through to "Free", so a brand who had paid $6,600 was shown an upgrade
// prompt on their own billing page.

export type PlanTier = 'FREE' | 'PROFESSIONAL' | 'ENTERPRISE' | 'FOUNDING';

export const CHARTER_PLAN_CODE = 'CHARTER_ANNUAL';

export function planTierOf(code: string | null | undefined): PlanTier | null {
    if (!code) return null;
    const upper = code.toUpperCase();

    // Charter is a billing state and a label, not a permission set.
    if (upper === CHARTER_PLAN_CODE) return 'PROFESSIONAL';
    if (upper === 'FOUNDING') return 'FOUNDING';
    if (upper.startsWith('PROFESSIONAL')) return 'PROFESSIONAL';
    if (upper.startsWith('ENTERPRISE')) return 'ENTERPRISE';
    if (upper.startsWith('FREE')) return 'FREE';
    return null;
}

export function isProfessionalTier(code: string | null | undefined): boolean {
    return planTierOf(code) === 'PROFESSIONAL';
}

export function isCharterPlan(code: string | null | undefined): boolean {
    return (code || '').toUpperCase() === CHARTER_PLAN_CODE;
}
